import(/* webpackMode: "eager" */ "/home/gs/apps/client-app/src/app/[locale]/(public)/not-found.tsx");
